import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import "./css/views/header/Header.css"
import {Container} from "react-bootstrap";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {HashRouter} from "react-router-dom";
import App from "./App";
import * as Sentry from "@sentry/react";
import Cookies from "js-cookie";
import {ToastContainer} from "react-toastify";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

/**
 * Main file
 */

dayjs.extend(customParseFormat);

Sentry.init({
    dsn: "https://cca33c1ee78fef83fad82a1caf34cb19@o4511291444101120.ingest.de.sentry.io/4511291544436816",
    sendDefaultPii: false,
    ignoreErrors: [
        "Network Error",
        "Failed to fetch",
    ],
    beforeSend(event, hint) {
        const error = hint.originalException;

        // Drop noisy API errors
        if (error instanceof Error) {
            if (error.message.includes("timeout")) {
                return null;
            }
        }

        return event;
    },
    normalizeDepth: 5
});

Sentry.setUser({
   username: Cookies.get("username")
});

ReactDOM.render(
    <HashRouter>
        <Container id="mainContainer" style={{padding: 0, margin: 0, }}>
            <App/>
            <ToastContainer position="top-center" autoClose={5000}/>
        </Container>
    </HashRouter>,
document.getElementById('root')
);